<template>
  <vs-popup class="popupSearchField" :title="title" :active.sync="showPopup">
    <vs-tabs v-if="tabGroupList.length > 1" v-model="tabGroupIndex">
      <vs-tab v-for="(groupName, tabIdx) of tabGroupList" :key="groupName" :label="groupName" @click="onClickTabGroup(tabIdx)" />
    </vs-tabs>
    <vs-tabs v-if="tabList.length > 1 || tabGroupList.length > 0" v-model="tabIndex" :key="tabsKey" style="margin-top: -16px">
      <vs-tab v-for="(tab, idx) of tabList" :key="tab.code + tab.label + idx" :label="tab.label" @click="onClickTab(tab.code)" />
    </vs-tabs>

    <div>
      <!-- 검색 -->
      <div v-if="isMobile" class="mobile flex justify-between items-center shadow rounded-lg pb-4 mb-4">
        <div class="flex">
          <ml-input v-model="search.keyword" ref="inputKeyword" class="w-full" placeholder="검색어 입력" @keyup.enter="handleClickSearch" />
        </div>
        <div>
          <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
        </div>
      </div>
      <div v-else style="border-bottom: 1px solid #e0e0e0" class="flex flex-wrap items-center justify-between gap-y-4 shadow rounded-lg p-5 mb-6">
        <div class="flex items-center gap-4">
          <p style="width: 114px" class="px-2">검색어</p>
          <ml-input v-model="search.keyword" ref="inputKeyword" class="w-full" @keyup.enter="handleClickSearch" />
        </div>
        <div class="ml-auto flex">
          <vs-button v-if="search.appliedKeyword" color="secondary" type="border" class="mr-2" @click="handleClickReset">초기화</vs-button>
          <div class="flex items-center">
            <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
          </div>
        </div>
      </div>
      <vs-row>
        <vs-col class="flex items-center gap-2 flex-wrap">
          <vs-select v-model="page.perPage" @input="handleClickSearch" autocomplete>
            <vs-select-item v-for="(item, index) in [10, 30, 50, 75, 100, 125, 150]" :key="index" :value="item" :text="`${item}개씩 보기`" />
          </vs-select>
          <template v-if="multiple">
            <vs-button color="secondary" type="border" class="m-0" @click="handleClickSelectPage">페이지 선택</vs-button>
            <vs-button
              v-if="selectAllActive"
              color="secondary"
              type="border"
              class="m-0"
              :loading="selectAllLoading"
              :disabled="selectAllLoading"
              @click="handleClickSelectAll"
            >
              {{ selectAllLoading ? "조회 중…" : "전체 선택" }}
            </vs-button>
          </template>
        </vs-col>
        <vs-col style="max-height: 500px; overflow-y: auto">
          <!-- 내부 종사자 -->
          <vs-table v-if="projectId === 2" stripe ref="table" :sst="true" :max-items="page.perPage" :data="fieldList" noDataText="데이터가 없습니다" @selected="handleItemClickDetail">
            <template #thead>
              <vs-th class=""><span class="w-full h-full whitespace-no-wrap">No.</span></vs-th>
              <vs-th class=""><span class="w-full h-full whitespace-no-wrap">사업장</span></vs-th>
              <vs-th class=""><span class="w-full h-full whitespace-no-wrap">담당주무관</span></vs-th>
              <vs-th class=""><span class="w-full h-full whitespace-no-wrap">부서(기관) 주소</span></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr v-for="(field, index) in data" :key="index" :class="(selectField && selectField.id === field.id) || (selectFields && selectFields.find((item) => item.id === field.id)) ? 'active' : ''" :data="field">
                <vs-td>{{ field.id }}</vs-td>
                <vs-td class="whitespace-no-wrap">{{ field.field_name }}</vs-td>
                <vs-td class="whitespace-no-wrap">{{ field.manager_name }}</vs-td>
                <vs-td style="min-width: 300px">{{ field.address }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <!-- 그외 -->
          <vs-table v-else stripe ref="table" :sst="true" :max-items="page.perPage" :data="fieldList" noDataText="데이터가 없습니다" @selected="handleItemClickDetail">
            <template slot="thead">
              <vs-th class="whitespace-no-wrap"><span class="w-full h-full">No.</span></vs-th>
              <vs-th class="whitespace-no-wrap"
                ><span class="w-full h-full">{{ getFieldName }}</span></vs-th
              >
              <vs-th class="whitespace-no-wrap"><span class="w-full h-full">주소</span></vs-th>
              <vs-th class="whitespace-no-wrap"><span class="w-full h-full">사업기간</span></vs-th>
              <vs-th class="whitespace-no-wrap"><span class="w-full h-full">사업금액</span></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr v-for="(field, index) in data" :key="index" :class="(selectField && selectField.id === field.id) || (selectFields && selectFields.find((item) => item.id === field.id)) ? 'active' : ''" :data="field">
                <vs-td class="whitespace-no-wrap">{{ field.id }}</vs-td>
                <vs-td class="whitespace-no-wrap">{{ field.field_name }}</vs-td>
                <vs-td style="min-width: 300px">{{ field.address }}</vs-td>
                <vs-td class="whitespace-no-wrap">{{
                  field.start_work_at || field.be_completed_at ? (field.start_work_at ? getFormattedDate(field.start_work_at) : "") + " ~ " + (field.be_completed_at ? getFormattedDate(field.be_completed_at) : "") : "-"
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">{{ field.deposit_amount ? new Intl.NumberFormat().format(parseInt(field.deposit_amount.replace(/,/g, "")) || 0) : "-" }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-col>

        <vs-col>
          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination :total="page.lastPage ? page.lastPage : 0" v-model="page.current" @change="handleChangePage"></k-pagination>
            </div>
          </div>
        </vs-col>

        <vs-col v-if="multiple" class="mt-2">
          <div class="grid gap-2">
            <h5>선택한 항목</h5>
            <div style="padding: 0 0.35rem; display: flex; gap: 0.375rem; flex-wrap: wrap; overflow: auto; border: 1px solid #cdcdcd; border-radius: 5px; padding: 0.35rem; min-height: 2.75rem">
              <vs-chip v-for="field in selectFields" :key="field.id" class="chip square m-0" closable @click="removeFieldItem(field)">
                {{ field.field_name }}
              </vs-chip>
            </div>
          </div>
        </vs-col>
        <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
          <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기 </vs-button>
          <vs-button class="" color="secondary" @click="handleClickSelect">선택</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";
import * as UiUtil from "@/util/UiUtil";
import moment from "moment";
import Vue from "vue";

export default {
  name: "PopupSearchFieldByType",
  components: { KPagination },
  props: {
    value: Boolean,
    selectId: [String, Number],
    useTypes: Array,
    projectInfo: Object,
    fieldTypes: Array,
    menuTitle: {
      type: String,
      default: "",
    },

    multiple: Boolean,
    initFields: Array,
    // 사업장 전체 선택 기능을 사용하는 경우
    selectAllActive: Boolean,
    // 참여 여부와 상관없이 모든 사업장을 조회하도록하는 경우
    showAll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getFieldName() {
      if (this.tabList.length === 1) {
        return this.tabList[this.tabIndex].label;
      } else if (this.tabList.length > 1) {
        return this.tabList[this.tabIndex].field_name;
      }

      return "사업장명";
    },
    title() {
      if (this.menuTitle !== "") return this.menuTitle;
      return `${this.getFieldName} 불러오기`;
    },
    /*
     * 2024-02-02 경남도청 전용
     * 중대시민재해분야 팝업에 사업장을 그룹별로 분리하기 위해 추가했음
     */
    tabGroupList() {
      if (this.projectId === 5) {
        return ["공중이용시설", "원료·제조물"];
      }
      return [];
    },
    tabList() {
      const list = [];

      if (this.projectId === 5) {
        switch (this.tabGroupIndex) {
        case 0: {
          /*
          도서관 - library
          박물관 및 미술관 - museum
          의료기관 - medical
          어린이집 - daycare
          업무시설 - office
          실내공연장 - indoor-auditorium
          둘이상용도건축물 - mixed-use-building
          건축물 - building
          항만(방파제) - port
          항만(부두) - port-dock
          교량 - bridge
          터널 - tunnel
          옹벽 - retaining-wall
          절토사면 - cutting-slope
           */
          list.push({ label: "건축물", field_name: "건축물", code: "building", projectId: this.projectId });
          list.push({ label: "교량", field_name: "교량", code: "bridge", projectId: this.projectId });
          list.push({ label: "도서관", field_name: "도서관", code: "library", projectId: this.projectId });
          list.push({ label: "둘이상용도건축물", field_name: "둘이상용도건축물", code: "mixed-use-building", projectId: this.projectId });
          list.push({ label: "박물관 및 미술관", field_name: "박물관 및 미술관", code: "museum", projectId: this.projectId });
          list.push({ label: "복합시설", field_name: "복합시설", code: "complex-facility", projectId: this.projectId });
          list.push({ label: "상수도", field_name: "상수도", code: "water-supply", projectId: this.projectId });
          // list.push({ label: '수도', field_name: '수도', code: 'waterworks', projectId: this.projectId })
          list.push({ label: "실내 체육시설", field_name: "실내 체육시설", code: "indoor-sports-facility", projectId: this.projectId });
          list.push({ label: "실내공연장", field_name: "실내공연장", code: "indoor-auditorium", projectId: this.projectId });
          list.push({ label: "어린이집", field_name: "어린이집", code: "daycare", projectId: this.projectId });
          list.push({ label: "업무시설", field_name: "업무시설", code: "office", projectId: this.projectId });
          list.push({ label: "옹벽", field_name: "옹벽", code: "retaining-wall", projectId: this.projectId });
          list.push({ label: "의료기관", field_name: "의료기관", code: "medical", projectId: this.projectId });
          list.push({ label: "절토사면", field_name: "절토사면", code: "cutting-slope", projectId: this.projectId });
          list.push({ label: "제방", field_name: "제방", code: "dike", projectId: this.projectId });
          list.push({ label: "청사", field_name: "청사", code: "government-building", projectId: this.projectId });
          list.push({ label: "터널", field_name: "터널", code: "tunnel", projectId: this.projectId });
          list.push({ label: "하수도", field_name: "하수도", code: "sewage-treatment", projectId: this.projectId });
          list.push({ label: "항만(방파제)", field_name: "항만(방파제)", code: "port", projectId: this.projectId });
          list.push({ label: "항만(부두)", field_name: "항만(부두)", code: "port-dock", projectId: this.projectId });
          break;
        }
        case 1: {
          /*
          급식소 - mass_feeding_facility
           */
          list.push({ label: "급식소", field_name: "급식소", code: "mass_feeding_facility", projectId: this.projectId });
          list.push({ label: "먹는물", field_name: "먹는물", code: "drinking-water", projectId: this.projectId });
          list.push({ label: "소규모수도", field_name: "소규모수도", code: "waterworks", projectId: this.projectId });
          list.push({ label: "승강기", field_name: "승강기", code: "lift", projectId: this.projectId });
          list.push({ label: "식품제조가공업", field_name: "식품제조가공업", code: "food-processing", projectId: this.projectId });
          list.push({ label: "어린이 놀이시설", field_name: "어린이 놀이시설", code: "kids-play-area", projectId: this.projectId });
        }
        }
      } else {
        for (const type of this.fieldTypes) {
          let field_name = "사업장";
          const label = type.name;
          if (type.name.indexOf("시설물") > -1) {
            field_name = "시설물";
          }

          list.push({ label, field_name, code: type.code, projectId: this.projectId });
        }
      }

      return list;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    fieldList() {
      const info = this.$store.state.project.fieldListInfo;
      const list = info.data;

      if (list) {
        this.page.current = info.current_page;
        this.page.perPage = info.per_page;
        this.page.lastPage = info.last_page;

        for (const field of list) {
          if (field.id === this.oldSelectFieldId) {
            this.oldSelectField = field;
            this.selectField = field;
            break;
          }
        }

        return list;
      } else {
        return [];
      }
    },
    getType() {
      return this.type;
    },
  },
  watch: {
    value(data) {
      this.showPopup = data;
      if (this.oldSelectField && this.oldSelectField.id) {
        this.selectField = this.oldSelectField;
      }

      // 팝업이 열리면, 검색어 입력창에 포커스가 오도록 한다
      if (data) {
        const self = this;
        Vue.nextTick().then(function () {
          if (self && self.$refs && self.$refs.inputKeyword) {
            self.$refs.inputKeyword.$el.querySelector("input").focus();
          }
        });

        // 팝업이 열리면, 첫번째 그룹을 선택하도록 한다
        if (this.tabGroupList.length > 0) {
          this.onClickTabGroup(0);
        }

        if (this.multiple) {
          this.selectFields = Object.assign([], this.initFields);
        }
      }
    },
    selectId(id) {
      this.oldSelectFieldId = id;
      if (this.fieldList && this.fieldList.length > 0) {
        for (const field of this.fieldList) {
          if (field.id === this.oldSelectFieldId) {
            try {
              this.oldSelectField = field;
              this.selectField = field;
            } catch (e) {
              //
            }
            break;
          }
        }
      }
    },
    initFields(data) {
      this.selectFields = Object.assign([], data);
    },
    showPopup(data) {
      if (data) {
        // 팝업이 열릴 때, 이미 적용되어 있는 키워드를 검색어로 적용한다
        this.search.keyword = this.search.appliedKeyword;
      }

      this.selectField = this.oldSelectField;

      if (this.fieldTypes && this.fieldTypes.length > 0) {
        this.selectedFieldCode = this.fieldTypes[0].code;
      }

      this.$emit("input", data);
      this.loadFieldList();
    },
  },
  data() {
    return {
      id: null,
      showPopup: false,
      isMobile: false,

      oldSelectFieldId: 0,
      oldSelectField: {},
      selectField: {},
      selectFields: [],

      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 50,
      },

      // 겅색
      search: {
        keyword: "", // 검색어
        appliedKeyword: "", // 적용된 검색어
      },
      // 선택된 탭 그룹
      tabGroupIndex: 0,
      tabIndex: 0,
      tabsKey: 0,

      // 선택된 탭과 연결된 FieldType의 code 값
      selectedFieldCode: "",

      // 전체 선택 조회 중 로딩
      selectAllLoading: false,
    };
  },

  async created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);

    this.showPopup = this.value;
    this.oldSelectFieldId = this.selectId;
    if (this.fieldTypes && this.fieldTypes.length > 0) {
      this.selectedFieldCode = this.fieldTypes[0].field_code;
    }
    if (this.initFields && this.initFields.length > 0) {
      this.selectFields = this.initFields;
    }
    // await this.loadFieldList()
  },

  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },

  methods: {
    getFormattedDate(dateStr) {
      const dateMoment = moment(dateStr);
      if (dateMoment.isValid()) {
        return dateMoment.format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    async loadFieldList() {
      // popupSearchField를 여러개 사용할 경우, 중복호출이 발생하는 문제가 있어서, 열려있는 팝업에 대해서만 처리
      if (!this.showPopup) return;

      const page = this.page.current;
      const perPage = this.page.perPage;
      const keyword = this.search.keyword;
      const projectId = this.projectId;
      const code = this.selectedFieldCode;
      const showAll = this.showAll;
      await this.$store.dispatch("project/LOAD_FIELD_LIST", {
        page,
        perPage,
        keyword,
        projectId,
        code,
        showAll,
      });

      // 검색어가 적용되면, 적용된 검색어를 저장한다
      this.search.appliedKeyword = this.search.keyword;
    },
    removeFieldItem(field) {
      this.selectFields = this.selectFields.filter((item) => item.id !== field.id);
    },

    onClickTabGroup(index) {
      this.tabsKey += 1;
      this.tabGroupIndex = index;
      this.tabIndex = 0;
      this.selectedFieldCode = this.tabList[0].code;
      this.page.current = 1;
      this.selectField = {};
      this.loadFieldList();
    },
    onClickTab(fieldCode) {
      if (fieldCode) {
        this.selectedFieldCode = fieldCode;
      }

      this.page.current = 1;
      this.selectField = {};

      this.loadFieldList();
    },

    handleClickClose() {
      this.selectFields = Object.assign([], this.initFields);
      this.$emit("input", false);
      this.$emit("handleClickClose");
    },

    handleClickSearch() {
      this.page.current = 1;
      this.loadFieldList();
    },
    handleClickReset() {
      this.search.keyword = "";
      this.page.current = 1;
      this.loadFieldList();
    },

    handleChangePage() {
      this.loadFieldList();
    },

    handleClickSelectPage() {
      // 현재 페이지 전체가 이미 선택된 경우 토글(현재 페이지만 해제), 아니면 현재 페이지 병합 (API 전체 객체 유지)
      const currentPageList = (this.fieldList || []).map((item) => ({ ...item }));
      const currentPageIds = new Set(currentPageList.map((item) => item.id));
      const selectedInCurrentPage = this.selectFields.filter((f) => currentPageIds.has(f.id));
      const isCurrentPageFullySelected =
        currentPageList.length > 0 && selectedInCurrentPage.length === currentPageList.length;

      if (isCurrentPageFullySelected) {
        this.selectFields = this.selectFields.filter((f) => !currentPageIds.has(f.id));
      } else {
        const existingIds = new Set(this.selectFields.map((f) => f.id));
        const toAdd = currentPageList.filter((item) => !existingIds.has(item.id));
        this.selectFields = [...this.selectFields, ...toAdd];
      }
    },

    handleItemClickDetail(data) {
      if (this.multiple) {
        if (this.selectFields.find((item) => item.id === data.id)) {
          this.selectFields = this.selectFields.filter((item) => item.id !== data.id);
        } else {
          this.selectFields.push(data);
        }
      } else {
        // 선택한 행을 다시 눌러도 선택이 풀리지 않게 한다 (알림 없이 풀려 빈 값이 적용되던 문제)
        this.selectField = data;
      }
    },

    handleClickSelect() {
      if (!this.multiple && (!this.selectField || !this.selectField.id)) {
        UiUtil.alertDialog("항목을 선택해 주세요.");
        return;
      }
      this.$emit("input", false);
      if (this.multiple) {
        this.$emit("handleClickMultipleSelect", this.selectFields);
      } else {
        this.$emit("handleClickSelect", this.selectField);
      }
      this.selectFields = [];
    },

    async handleClickSelectAll() {
      // store를 갱신하지 않고 전체 목록만 100개씩 나눠 조회 후 병합/토글 처리.
      const currentTab = this.tabList[this.tabIndex];
      const code = currentTab ? currentTab.code : this.selectedFieldCode;
      const projectId = this.projectId;
      const showAll = this.showAll;
      const perPage = 100;

      this.selectAllLoading = true;
      try {
        const allList = [];
        let page = 1;
        let lastPage = 1;

        do {
          const res = await this.$store.dispatch("project/FETCH_FIELD_LIST", {
            page,
            perPage,
            projectId,
            code,
            showAll,
          });
          const list = res.data || [];
          list.forEach((item) => {
            allList.push({ ...item });
          });
          lastPage = res.last_page !== undefined && res.last_page !== null ? res.last_page : 1;
          page += 1;
        } while (page <= lastPage);

        const currentTabIds = new Set(allList.map((item) => item.id));
        const selectedIdsInCurrentTab = this.selectFields.filter((f) => currentTabIds.has(f.id));
        const isCurrentTabFullySelected =
          allList.length > 0 && selectedIdsInCurrentTab.length === allList.length;

        if (isCurrentTabFullySelected) {
          this.selectFields = this.selectFields.filter((f) => !currentTabIds.has(f.id));
        } else {
          const existingIds = new Set(this.selectFields.map((f) => f.id));
          const toAdd = allList.filter((item) => !existingIds.has(item.id));
          this.selectFields = [...this.selectFields, ...toAdd];
        }
      } finally {
        this.selectAllLoading = false;
      }
    },

    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
  },
};
</script>

<style>
#popupSearchCompany > .vs-popup {
  width: 860px !important;
}

#popupSearchCompany > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupSearchCompany > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;
}
</style>

<style scoped>
.table-layout {
  border: 1px solid #cdcdcd;
}

.table-layout .trow {
  border-bottom: 1px solid #cdcdcd;
}

.table-layout .tcol {
  border-right: 1px solid #cdcdcd;
}

.vs-con-table.stripe .tr-values.active {
  background: rgb(102, 112, 203) !important;
  color: #fff;
  font-weight: bold;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
}

th,
td {
  text-align: center !important;
}
th .vs-table-text {
  justify-content: center;
}
.textCenter {
  text-align: center;
}
</style>

<style lang="scss">
.popupSearchField {
  z-index: 53001;
}
.popupSearchField > .vs-popup {
  width: 90% !important;
  @media print, screen and (min-width: theme("screens.xl")) {
    width: 1200px !important;
  }
}

.popupSearchField .vs-tabs--content {
  min-height: inherit !important;
}

.search-label {
  width: 80px;
  @media print, screen and (min-width: theme("screens.xl")) {
    width: 114px;
  }
}
</style>

<style lang="scss">
.chip.square {
  overflow: hidden;
  flex-shrink: 0;

  background: #ffffff;
  border: solid 1px #d7d7d7;

  border-radius: 5px;

  & > span {
    flex: 1 0 auto;

    font-size: 13px;
    color: #2c2c2c;

    text-overflow: ellipsis;
  }

  & > button {
    color: #2c2c2c;
    background: inherit;
  }
}
</style>
